import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useGlobalName from '@hooks/useGlobalName';
import { ShopRecommendedItemRow } from '@models/item/recommendedItem';
import { useFlow } from '@router/stackflow';
import { pressActionEffect } from '@styles/mixin';
import { useTranslation } from 'react-i18next';

import Badge from './Badge';

interface Props {
    shopId: string;
    item: ShopRecommendedItemRow;
}

function RecommendationItem({ item, shopId }:Props) {
    const {
        thumbnailUrl, name, salePrice, shopItemId, badges, nameJa, nameEn,
    } = item;
    const itemName = useGlobalName({ nameJa, nameEn, name });
    const priceUnit = usePriceUnit();
    const { t } = useTranslation('item');
    const { push } = useFlow();

    const handleChangeItem = () => {
        push('ItemActivity', { itemId: shopItemId, shopId });
    };

    return (
        <Container spacing={16}
            onClick={handleChangeItem}
            css={pressActionEffect} >
            <Image src={thumbnailUrl}
                alt={itemName}
                width={96} />
            <Column justify='space-between'
                fullHeight >
                <Column spacing={4}>
                    <Row spacing={4}>
                        {badges.map((badge, index) => (
                            <Badge key={index.toString()}>{badge}</Badge>
                        ))}
                    </Row>
                    <Text>{itemName}</Text>
                </Column>
                <Text size='xl' fontWeight='bold'>
                    {salePrice.toLocaleString()}{priceUnit}
                </Text>
            </Column>
        </Container>
    );
}

const Container = styled(Row)`
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.20);
    background-color: var(--color-white);
    border-radius: 12px;
    overflow: hidden;
    padding: 18px 14px;
    height: 100%;
    min-width: 275px;
    max-width: 275px;
    scroll-snap-align: start;
    scroll-snap-stop: always;
`;

export default RecommendationItem;
